import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/stores/authStore'
import { authApi, mergeSubscriptionParameters } from '@/api/auth'
import { ROUTES } from '@/utils/constants'
import { Alert, Button } from '@mui/material'
import { useState } from 'react'

export function ImpersonationBanner() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const isImpersonating = useAuthStore((state) => state.isImpersonating)
  const stopImpersonation = useAuthStore((state) => state.stopImpersonation)
  const setAuth = useAuthStore((state) => state.setAuth)
  const [loading, setLoading] = useState(false)

  const handleStopImpersonation = async () => {
    const adminToken = stopImpersonation()
    if (!adminToken) return
    setLoading(true)
    try {
      const profile = await authApi.getProfile()
      const merged = await mergeSubscriptionParameters(profile)
      setAuth(merged, adminToken)
      navigate(ROUTES.ADMIN_USERS, { replace: true })
    } catch (err) {
      console.error('Failed to restore admin session:', err)
    } finally {
      setLoading(false)
    }
  }

  if (!isImpersonating) return null

  const displayName =
    user?.display_name ||
    (user?.first_name && user?.surname
      ? `${user.surname} ${user.first_name}`
      : user?.email) ||
    user?.nickname ||
    t('impersonation.user')

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleStopImpersonation}
          disabled={loading}
        >
          {t('impersonation.backToAdmin')}
        </Button>
      }
    >
      {t('impersonation.actingAs', { name: displayName })}
    </Alert>
  )
}
